import React from "react";
import styles from "./CustomRadio.module.css";

interface CustomRadioProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
  id: string;
  name?: string;
  disabled?: boolean;
  className?: string;
  value?: string;
}

const CustomRadio: React.FC<CustomRadioProps> = ({
  checked,
  onChange,
  label,
  id,
  name,
  disabled = false,
  className = "",
  value,
}) => {
  return (
    <label htmlFor={id} className={`${styles.label} ${disabled ? "disabled" : ""} ${className}`} data-testid="CustomRadio">
      <input
        data-testid="customRadio_membershipOption"
        type="checkbox"
        id={id}
        name={name}
        value={value}
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        disabled={disabled}
        className={styles.input}
      />
      <span className={styles.box}>
        {checked && <span className={styles.dot} />}
      </span>
      {label && <span className={styles.text}>{label}</span>}
    </label>
  );
};

export default CustomRadio;